/**
 * Checks if a value is a plain object.
 */
export function isPlainObject(value) {
  if (!value || typeof value !== "object") return false;
  return Object.getPrototypeOf(value) === Object.prototype;
}

/**
 * Checks if a value is a plain array.
 */
export function isPlainArray(value) {
  return Array.isArray(value) && Object.getPrototypeOf(value) === Array.prototype;
}

/**
 * Checks if a value is a plain object or array.
 */
export function isPlain(value) {
  return isPlainObject(value) || isPlainArray(value);
}
//# sourceMappingURL=is-plain.mjs.map